const config = {
    build_number: '615909',
    build_timestamp: '2026-09-09T16:28:22.885Z',
    build_commit: '0830598d70db48b5a6a59205907885c9925d70d7',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
